export enum ETimeBreak {
	FIFTEEN_MINUTES = 15,
	THIRTY_MINUTES = 30,
	FORTY_FIVE_MINUTES = 45,
	ONE_HOUR = 60,
}
